import UserRole from '../enums/UserRole';
import Message from './Message';

export default class CareTicket {
  user: string = '';
  name: string = '';
  role: UserRole = UserRole.UNKNOWN;
  avatar: string = '';
  message: Message = new Message();
  unread: number = 0;
  timestamp: number = 0;
}
